/**
 * New encounter/claims flow (spec §7) — shared by the Encounters table, card
 * and details modal so all three agree on when "Submit Claim" is offered.
 *
 * Submit mode is on when the API reports `submit_separation_enabled`
 * (useClaimsRollout). Off, every caller keeps the existing Checkout action.
 */

export const SUBMIT_CLAIM_LABEL = 'Submit Claim';

/** Same synthetic role gate the Checkout action uses (index.js userRoleId). */
const CAN_ACT_ROLES = [1, 3];

/**
 * An encounter can have its claim submitted when it is pending submission —
 * claimable PA-approved items and no claim yet — whether it is still checked in
 * or was checked out automatically. Rows loaded without the claim-state fields
 * (pending_submission == null) fall back to "still open".
 */
export function canSubmitClaimFor(record, userRoleId) {
  if (!CAN_ACT_ROLES.includes(userRoleId)) return false;
  if (record?.pending_submission === true) return true;
  if (record?.pending_submission == null) return Number(record?.checkin_status) === 0;
  return false;
}

export function canCheckoutFor(record, userRoleId) {
  return Number(record?.checkin_status) === 0 && CAN_ACT_ROLES.includes(userRoleId);
}

/** Status-filter values that select the new-flow list scopes on /v2/checkins. */
export const NEW_FLOW_STATUS_SCOPES = {
  claimable: { list_scope: 'claimable' },
  pending: { list_scope: 'pending_submission', previous_months_only: 1 },
};

export const NEW_FLOW_STATUS_OPTIONS = [
  { value: 'claimable', label: 'Awaiting claim' },
  { value: 'pending', label: 'Pending submission (previous months)' },
];
